import maleMuscleGroup from 'url:../../../../../../../assets/images/muscle-group/male/program-focus.png';
import maleMuscleGroupFullBody from 'url:../../../../../../../assets/images/muscle-group/male/program-focus-full-body.png';
import maleMuscleGroupUpperBody from 'url:../../../../../../../assets/images/muscle-group/male/program-focus-upper-body.png';
import maleMuscleGroupLowerBody from 'url:../../../../../../../assets/images/muscle-group/male/program-focus-lower-body.png';
import maleMuscleGroupBack from 'url:../../../../../../../assets/images/muscle-group/male/program-focus-back.png';
import maleMuscleGroupCore from 'url:../../../../../../../assets/images/muscle-group/male/program-focus-core.png';
import maleMuscleGroupGlutes from 'url:../../../../../../../assets/images/muscle-group/male/program-focus-glutes.png';

import femaleMuscleGroup from 'url:../../../../../../../assets/images/muscle-group/female/program-focus.png';
import femaleMuscleGroupFullBody from 'url:../../../../../../../assets/images/muscle-group/female/program-focus-full-body.png';
import femaleMuscleGroupUpperBody from 'url:../../../../../../../assets/images/muscle-group/female/program-focus-upper-body.png';
import femaleMuscleGroupLowerBody from 'url:../../../../../../../assets/images/muscle-group/female/program-focus-lower-body.png';
import femaleMuscleGroupBack from 'url:../../../../../../../assets/images/muscle-group/female/program-focus-back.png';
import femaleMuscleGroupCore from 'url:../../../../../../../assets/images/muscle-group/female/program-focus-core.png';
import femaleMuscleGroupGlutes from 'url:../../../../../../../assets/images/muscle-group/female/program-focus-glutes.png';

export const MuscleGroupImages = {
  male: {
    base: maleMuscleGroup,
    full_body: maleMuscleGroupFullBody,
    upper_body: maleMuscleGroupUpperBody,
    lower_body: maleMuscleGroupLowerBody,
    back: maleMuscleGroupBack,
    core: maleMuscleGroupCore,
    glutes: maleMuscleGroupGlutes,
  },
  female: {
    base: femaleMuscleGroup,
    full_body: femaleMuscleGroupFullBody,
    upper_body: femaleMuscleGroupUpperBody,
    lower_body: femaleMuscleGroupLowerBody,
    back: femaleMuscleGroupBack,
    core: femaleMuscleGroupCore,
    glutes: femaleMuscleGroupGlutes,
  },
};
